import React from "react";
import { View } from "react-native";

import AboutMe from "./Components/AboutMe";
import BasicAttributes from "./Components/BasicAttributes";
import MultiSelectionAttributes from "./Components/MultiSelectionAttributes";
import PhysicalAttributes from "./Components/PhysicalAttributes";

import { UserInterestAttributeSet } from "@/schemas/profile/attributes/UserInterestAttributeSet";
import { UserLanguageAttributeSet } from "@/schemas/profile/attributes/UserLanguageAttributeSet";
import { UserSeekingAttributeSet } from "@/schemas/profile/attributes/UserSeekingAttributeSet";
import { type UserProfileAttributes } from "@/schemas/profile/UserProfileAttributes";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type AboutUserTabProps = {
  attributes: UserProfileAttributes;
};

function AboutUserTab({ attributes }: AboutUserTabProps): React.JSX.Element {
  const seekingItems = attributes.seeking
    .map((id) => UserSeekingAttributeSet.map[id])
    .filter((item): item is AttributeValue => item !== undefined);

  const languageItems = attributes.languages
    .map((id) => UserLanguageAttributeSet.map[id])
    .filter((item): item is AttributeValue => item !== undefined);

  const interestItems = attributes.interests
    .map((id) => UserInterestAttributeSet.map[id])
    .filter((item): item is AttributeValue => item !== undefined);

  return (
    <View>
      <AboutMe bio={attributes.aboutMe} />
      <BasicAttributes attributes={attributes} />
      <PhysicalAttributes attributes={attributes} />
      {interestItems.length > 0 && (
        <MultiSelectionAttributes
          icon="list-outline"
          title="Interests"
          items={interestItems}
        />
      )}
      {seekingItems.length > 0 && (
        <MultiSelectionAttributes
          icon="search-outline"
          title="Seeking"
          items={seekingItems}
        />
      )}
      {languageItems.length > 0 && (
        <MultiSelectionAttributes
          icon="language-outline"
          title="Languages"
          items={languageItems}
        />
      )}
    </View>
  );
}

export default AboutUserTab;
